"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWalletSendTransaction = void 0;

var _react = require("react");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* --- Effect --- */
var useWalletSendTransaction = () => {
  var [transaction, setTransaction] = (0, _react.useState)(undefined);
  var [wallet, setWallet] = (0, _react.useState)(undefined);

  var init = (wallet, tx) => {
    setTransaction(tx);
    setWallet(wallet);
  };
  /* --- Boolean : States --- */


  var [isTransactionBroadcast, setIsTransactionBroadcast] = (0, _react.useState)(false);
  var [isTransactionConfirmed, setIsTransactionConfirmed] = (0, _react.useState)(false);
  /* --- Transaction : States --- */

  var [transactionHash, setTransactionHash] = (0, _react.useState)(undefined);
  var [transactionBroadcast, setTransactionBroadcast] = (0, _react.useState)(undefined);
  /* --- Error : States --- */

  var [transactionConfirmed, setTransactionConfirmed] = (0, _react.useState)(undefined);
  var [transactionBroadcastError, setTransactionBroadcastError] = (0, _react.useState)(undefined);
  var [transactionConfirmedError, setTransactionConfirmedError] = (0, _react.useState)(undefined);
  /* --- Broadcast Transaction :: Effect --- */

  (0, _react.useEffect)(() => {
    if (transaction && wallet && !isTransactionBroadcast) {
      var runEffect =
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(function* () {
          try {
            var _transactionBroadcast = yield wallet.sendTransaction(transaction);

            setIsTransactionBroadcast(true);
            setTransactionHash(_transactionBroadcast.hash);
            setTransactionBroadcast(_transactionBroadcast);
          } catch (error) {
            console.log(error);
            setTransactionBroadcastError(error);
          }
        });

        return function runEffect() {
          return _ref.apply(this, arguments);
        };
      }();

      runEffect();
    }
  }, [transaction, wallet]);
  /* --- Wait for Transaction :: Effect --- */

  (0, _react.useEffect)(() => {
    if (isTransactionBroadcast && transactionHash) {
      var runEffect =
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(function* () {
          try {
            var _transactionConfirmed = yield wallet.provider.waitForTransaction(transactionHash);

            setIsTransactionConfirmed(true);
            setTransactionConfirmed(_transactionConfirmed);
          } catch (error) {
            setTransactionConfirmedError(error);
          }
        });

        return function runEffect() {
          return _ref2.apply(this, arguments);
        };
      }();

      runEffect();
    }
  }, [isTransactionBroadcast, transactionHash]);
  return {
    init,
    isBroadacast: isTransactionBroadcast,
    isConfirmed: isTransactionConfirmed,
    hash: transactionHash,
    broadcast: transactionBroadcast,
    confirmed: transactionConfirmed,
    broadcastError: transactionBroadcastError,
    confirmedError: transactionConfirmedError
  };
};

exports.useWalletSendTransaction = useWalletSendTransaction;